import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faCommentAlt, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { Chat } from "../../components/Icons"
import { T } from "react-translator-component";


const CheckinMessagesCard = ({ data, pathname, hotelCode, agent }) => {
    return (
        <div className="mx-2 mt-3 checkin-messages-card-stay">
            <NavLink
                className="d-block px-2 mb-3"
                style={{
                    boxShadow: "1px 4px 15px rgba(0,0,0,0.20)",
                    background: "#FFF",
                    borderRadius: 8,
                    padding: 10,
                    color: "#444",
                    height: 100,
                }}
                to={`/${hotelCode}/checkin/messages`}
                state={{ from: pathname }}
            >
                <div className="d-flex mt-1">
                    <div
                        className="mr-2"
                        style={{
                            width: 70,
                            height: 70,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            textAlign: 'center',
                            background: '#FFF',
                            borderRadius: 8,
                            border: '1px solid #EEE',
                            flexShrink: 0,
                        }}
                    >
                        <Chat width={50} height={50} />
                    </div>

                    <div className="d-flex flex-column">
                        <div
                            style={{
                                fontSize: 14,
                                fontWeight: "bold",
                                lineHeight: 2,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                color: "#777777",
                            }}
                        >
                            {T("status.checkin.chat")}
                            <div
                                style={{
                                    fontSize: 12,
                                    fontWeight: "bold",
                                    color: "#999999",

                                }}
                            >
                                {T("status.checkin.chat-desc")}
                            </div>
                        </div>
                    </div>
                </div>
            </NavLink>
        </div>
    )
}

export default CheckinMessagesCard